import { render, staticRenderFns } from "./ParticularsCell.vue?vue&type=template&id=04b22b9c&scoped=true&"
import script from "./ParticularsCell.vue?vue&type=script&lang=js&"
export * from "./ParticularsCell.vue?vue&type=script&lang=js&"
import style0 from "./ParticularsCell.vue?vue&type=style&index=0&id=04b22b9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b22b9c",
  null
  
)

export default component.exports